import { styled, StyleProps } from "../../styles"
import { getButtonCss, BaseButtonProps, ButtonStyleProps } from "../../Button/ButtonStyles"

type Props = ButtonStyleProps & StyleProps

const GroupTrigger = styled.button<BaseButtonProps>((props: Props) => ({
  ...getButtonCss(props),
  ...props.theme.fonts.body,
  display: `flex`,
  alignItems: `center`,
  justifyContent: `space-between`,
  width: `100%`,
  height: `40px`,
  textAlign: `left`,
  textDecoration: `none`,
  textTransform: `none`,
  color: props.theme.palette.white,
  padding: props.theme.spacing(0, 6),
  borderRadius: 0,
  borderBottom: `1px solid ${props.theme.palette.coal.light}`,
}))

export default GroupTrigger
